module.exports = __webpack_public_path__ + "img/2.e391c4ed.png";